<template>
    <footer class="bg-footer">
        <div class="container py-5">
            <div class="row text-center">
                <div class="col-md-3 mb-3">
                    <router-link class="text-decoration-none h5 text-flow font-cursive" :to="{ name: 'about' }">{{ lang == 'es' ? 'Acerca de Nosotros' : 'About Us' }}</router-link>
                </div>
                <div class="col-md-3 mb-3">
                    <router-link class="text-decoration-none h5 text-flow font-cursive" :to="{ name: 'experience' }">{{ lang == 'es' ? 'Experiencia Profesional' : 'Professional Experience' }}</router-link>
                </div>
                <div class="col-md-3 mb-3">
                    <router-link class="text-decoration-none h5 text-flow font-cursive" :to="{ name: 'services' }">{{ lang == 'es' ? 'Servicios' : 'Services' }}</router-link>
                </div>
                <div class="col-md-3 mb-3">
                    <router-link class="text-decoration-none h5 text-flow font-cursive" :to="{ name: 'contact' }">{{ lang == 'es' ? 'Contáctenos' : 'Contact us' }}</router-link>
                </div>
                <div class="col-md-12">
                  <div class="container">
                    <hr>
                  </div>
                  <div class="row py-3">
                    <div class="col-lg-4 col-md-12 text-center">
                      <h6 class="text-lead mb-0">Lic. Jorge Augusto Román Garcia</h6>
                      <div>
                        <small class="text-muted">{{ lang == 'es' ? 'Socio Director' : 'CEO' }}</small>
                      </div>
                      <a class="text-flow" href="mailto:joroman@romanyroman.com?Subject=Interesado%20en%20el%20curso">joroman@romanyroman.com</a>
                    </div>
                    <div class="col-lg-4 col-md-12 text-center">
                      <hr class="d-lg-none d-block">
                      <h6 class="text-lead mb-0">Lic. Jorge Augusto Román Pineda</h6>
                      <div>
                        <small class="text-muted">{{ lang == 'es' ? 'Socio Consultoría' : 'MANAGING PARTNER' }}</small>
                      </div>
                      <a class="text-flow" href="mailto:jorge@romanyroman.com?Subject=Interesado%20en%20el%20curso">jorge@romanyroman.com</a>
                    </div>
                    <div class="col-lg-4 col-md-12 text-center">
                      <hr class="d-lg-none d-block">
                      <h6 class="text-lead mb-0">Licda. Doris Román de Amado</h6>
                      <div>
                        <small class="text-muted">{{ lang == 'es' ? 'Socio Gerente' : 'ADMINISTRATION MANAGER (PARTNER)' }}</small>
                      </div>
                      <a class="text-flow" href="mailto:administracion@romanyroman.com?Subject=Interesado%20en%20el%20curso">administracion@romanyroman.com</a>
                    </div>
                  </div>
                  <div class="container mb-5">
                    <hr>
                  </div>
                  <a href="https://www.facebook.com/Roman-Roman-Auditores-y-Abogados-104324600982580/" target="_blank" class="text-decoration-none text-facebook" ><i class="fa fa-facebook-official fa-2x"></i></a>
                  <a href="https://www.linkedin.com/company/rom%C3%A1n-rom%C3%A1n" target="_blank" class="text-decoration-none text-info mx-2" ><i class="fa fa-linkedin-square fa-2x"></i></a>
                  <a href="https://instagram.com/romanauditores?igshid=sb4vbfrdpqsi" target="_blank" class="text-decoration-none text-danger" ><i class="fa fa-instagram fa-2x"></i></a>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  data(){
    return{
      lang: window.lang
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/navfooter.vue